import React, { useContext, useCallback } from "react";
import { UI } from "@wwimmo/ui";
import { RootStoreContext } from "src/stores/RootStore";
import { useTranslation } from "react-i18next";
import styles from "./ManageUser.module.css";
import { ImportUsersProgressModal } from "./import-users/ImportUsersProgressModal";
import { IUserImportProcess } from "src/stores/CustomerDetailPageStore";

interface ManageUserProps {
    customerId?: string;
    userImportProcess?: IUserImportProcess;
}

const ManageUser = (props: ManageUserProps) => {
    const { t } = useTranslation();
    const { importUsersProgressModalStore } = useContext(RootStoreContext);

    const { customerId, userImportProcess } = props;
    const importData = userImportProcess?.importData?.users ?? [];

    // Der Store merkt sich den laufenden Import erst beim Öffnen, damit ein Neuladen der
    // Detailseite die ID nicht überschreibt, während das Modal offen ist.
    const onClickUserImportButton = useCallback(() => {
        importUsersProgressModalStore.setUserimportprocessesId(userImportProcess?.id ?? "");
        importUsersProgressModalStore.setisImportUsersProgressModalDisplayed(true);
    }, [importUsersProgressModalStore, userImportProcess?.id]);

    return (
        <>
            <UI.Button
                label={t("user_import.title")}
                className={styles.buttonUserImport}
                onClick={onClickUserImportButton}
            />
            <ImportUsersProgressModal importdata={importData} customerid={customerId ?? ""} />
        </>
    );
};

export default ManageUser;
